/* ================================================== */
/* Scripts ========================================== */
/* ================================================== */

// WordPress's jQuery (enqueued as a dependency) — bundling our own shipped a second copy.
const $ = window.jQuery;
require('@popperjs/core');
const bootstrap = require('bootstrap');
const staffFrame = require('./staff-frame');

// Swiper and GLightbox are loaded as separate scripts (not bundled)
// They're available globally as window.Swiper and window.GLightbox

$(function () {
  container_fix();
  glightbox_init();
  swiper_init();
  headerFix();
  adminBar();
  noticeBanner(0.075, '.standard-notice-banner .slider-track');
  removeStyleTagsFromWysiwyg();
  staffFrame();
  accordionHeaderHeight();

  function accordionHeaderHeight() {
    $('.standard-accordion .accordion[id^="itemsAccordion"]').each(function () {
      var $headers = $(this).find('.accordion-header');
      if (!$headers.length) return;

      // Reset heights
      $headers.css('height', '');

      // Group headers by row based on their top offset
      var rows = {};
      $headers.each(function () {
        var top = Math.round($(this).offset().top);
        if (!rows[top]) rows[top] = [];
        rows[top].push($(this));
      });

      // Set min-height per row
      $.each(rows, function (top, items) {
        var maxHeight = 0;
        $.each(items, function (i, $el) {
          var h = $el.outerHeight();
          if (h > maxHeight) maxHeight = h;
        });
        $.each(items, function (i, $el) {
          $el.css('height', maxHeight + 'px');
        });
      });
    });
  }

  // Toggle accordion items by row: opening any item opens its row mates and
  // closes every item in other rows; closing an item closes its row mates.
  var syncingRow = false;
  function getRowItems($accordion, $item) {
    var headerTop = Math.round($item.find('> .accordion-header').offset().top);
    return $accordion.find('> .accordion-item').filter(function () {
      var $header = $(this).find('> .accordion-header');
      return $header.length && Math.round($header.offset().top) === headerTop;
    });
  }
  $(document).on('click', '.standard-accordion .accordion-button, .standard-certifications .accordion-button', function (e) {
    if (syncingRow) return;
    var $button = $(this);
    var $item = $button.closest('.accordion-item');
    var $accordion = $item.closest('.accordion');
    if (!$accordion.length) return;

    // Bootstrap toggles `collapsed` class on the same click before our handler
    // runs (both bubble-phase listeners on document). After Bootstrap's toggle,
    // the absence of `collapsed` means the panel is now opening.
    var willOpen = !$button.hasClass('collapsed');
    var $rowItems = getRowItems($accordion, $item);

    syncingRow = true;

    // Sync the row mates of the clicked item to match its new state.
    $rowItems.not($item).each(function () {
      var $sibButton = $(this).find('> .accordion-header > .accordion-button');
      if (!$sibButton.length) return;
      var siblingOpen = !$sibButton.hasClass('collapsed');
      if (willOpen !== siblingOpen) {
        $sibButton[0].click();
      }
    });

    // When opening a row, close any items in other rows so only one row is
    // expanded at a time.
    if (willOpen) {
      $accordion.find('> .accordion-item').not($rowItems).each(function () {
        var $otherButton = $(this).find('> .accordion-header > .accordion-button');
        if (!$otherButton.length) return;
        if (!$otherButton.hasClass('collapsed')) {
          $otherButton[0].click();
        }
      });
    }

    setTimeout(function () { syncingRow = false; }, 50);
  });

  // Open Positions: when a vacancy is expanded, scroll so the top of that
  // listing is in view, allowing for the fixed site header.
  //
  // Bootstrap's data-bs-parent collapses the previously open listing at the same
  // time as this one expands. We must NOT wait for that sibling to finish closing
  // and then scroll — that produces a "double scroll": the page first reflows
  // upward as the sibling collapses (the browser even clamps the scroll position
  // up when the document shrinks), and then we scroll back down to the new item.
  //
  // Instead we fire on `show.bs.collapse` (the *start* of the expand) and scroll
  // straight to where this item's header WILL be once the collapsing sibling has
  // gone. If an open sibling sits above this item, its height is about to be
  // removed from the layout above us, so we subtract it up front. The smooth
  // scroll then runs concurrently with the collapse/expand animation — one
  // continuous motion to the final resting position.
  //
  // NOTE: must use a *native* listener, not jQuery's `.on('show.bs.collapse')`.
  // jQuery treats the dots in `show.bs.collapse` as namespaces (listening for a
  // bare `show` event), so a jQuery delegate never runs. A native addEventListener
  // catches Bootstrap's real native event.
  document.addEventListener('show.bs.collapse', function (e) {
    var collapse = e.target;
    if (!collapse || !collapse.closest || !collapse.closest('.open-positions-wrapper')) return;
    var item = collapse.closest('.accordion-item');
    if (!item) return;
    var accordion = collapse.closest('.accordion');

    var header = document.getElementById('header');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    // #header is position:fixed. On desktop (>=1200px) its content is d-xl-none,
    // so it's an empty transparent spacer (the nav lives in the side menu) and its
    // height alone is a safe offset. On mobile/tablet (<1200px) #header is a solid
    // bar with a drop shadow (box-shadow: 0 4px 15px) that overlays content, so we
    // add extra clearance to lift the just-opened listing's toggle button clear of
    // the bar + its shadow — otherwise the button sits behind the header and only
    // the accordion body is visible.
    var isMobile = window.matchMedia('(max-width: 1199px)').matches;
    var headerOffset = headerHeight + (isMobile ? 32 : 16);

    // Predict the upward shift: sum the full content height of any sibling collapse
    // that is currently open (or already collapsing via data-bs-parent) and sits
    // above this item. scrollHeight gives the natural height even mid-animation.
    var itemTop = item.getBoundingClientRect().top;
    var shrinkAbove = 0;
    if (accordion) {
      var siblings = accordion.querySelectorAll('.accordion-collapse.show, .accordion-collapse.collapsing');
      Array.prototype.forEach.call(siblings, function (other) {
        if (other === collapse) return;
        var otherItem = other.closest('.accordion-item');
        if (otherItem && otherItem.getBoundingClientRect().top < itemTop) {
          shrinkAbove += other.scrollHeight;
        }
      });
    }

    var target = window.scrollY + itemTop - headerOffset - shrinkAbove;
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  });

  function headerFix() {
    var $header = $('header');
    if (!$header.length) return;
    var headerHeight = $header.outerHeight();
    var $firstSection = $('body main');
    var $sideBar = $('.side-menu-wrapper');
    var $mobileMenu = $('#navigation-mobile');

    if ($firstSection.length) {
      $firstSection.css('margin-top', headerHeight + 'px');
    }

    if ($sideBar.length) {
      $sideBar.css('top', headerHeight + 'px');
    }

    if ($mobileMenu.length) {
      $mobileMenu.css('top', headerHeight + 'px');
      $mobileMenu.css('height', 'calc(100% - ' + headerHeight + 'px');
    }
  }

  /* Applies the "active" class to hyperlinks within the header */
  $('header .nav [href]').each(function () {
    if (this.href === window.location.href) {
      $(this).addClass('active');
    }
  });

  /* Handles resize events */
  $(window).on('resize', function () {
    container_fix();
    headerFix();
    adminBar();
    accordionHeaderHeight();
  });

  /* Handles scroll events */
  $(window).on('scroll', function () {
    check_scroll();
  });

  $(window).one('wheel touchstart keydown mousedown', function () { userHasScrolled = true; });

  /* The page may load already scrolled — set the logo state straight away */
  check_scroll();
  $(window).on('load pageshow', check_scroll);

  /* Handles header offset when logged in */
  function adminBar() {
    if ($('body').hasClass('logged-in')) {
      var $adminBarEl = $('#wpadminbar');
      var adminBarHeight = $adminBarEl.length ? $adminBarEl.outerHeight() : 0;
      var $header = $('header');
      if ($header.length) {
        $header.css('top', adminBarHeight + 'px');
      }
    }
  }

  // Desktop Menu Toggle
  $('#navigation li .submenu-toggle, #navigation-mobile li .submenu-toggle').on('click', function () {
    var $button = $(this);
    var opening = !$button.hasClass('open');
    $button.siblings('.submenu').toggleClass('open');
    $button.toggleClass('open');

    // Desktop side menu only: a parent with no page of its own loads its first
    // child once opened. Wait for the 400ms unfurl so it reads as one motion.
    var landing = $button.data('landing');
    if (opening && landing && $button.closest('#navigation').length) {
      setTimeout(function () { window.location.href = landing; }, 400);
    }
  });

  /* Enables smooth scrolling on hyperlinks tagged with "smooth" class */
  $('a.smooth[href*="#"]').on('click', function (event) {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      var $target = $(this.hash);
      var $header = $('header');
      var offset = $header.length ? $header.outerHeight() : 0;

      if (!$target.length) {
        $target = $('[name=' + this.hash.slice(1) + ']');
      }

      if ($target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: $target.offset().top - offset
        }, 500);
      }
    }
  });

  // Scroll on page load if hash exists
  if (window.location.hash) {
    var $target = $(window.location.hash);
    var $header = $('header');
    var offset = $header.length ? $header.outerHeight() : 0;

    if (!$target.length) {
      $target = $('[name=' + window.location.hash.slice(1) + ']');
    }

    if ($target.length) {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $target.offset().top - offset
        }, 500);
      }, 100);
    }
  }

  /* Triggering the burger menu upon click */
  $('#burger').on('click', function () {
    open = !open;
    menu_toggle(open);
  });

  /* Triggering a tag click on card click for nested a tags */
  $('.navigation-card').on('click', function (e) {
    if (!$(e.target).closest('a, button').length) {
      var $link = $(this).find('a').first();
      if ($link.length) {
        var url = $link.attr('href');
        var target = $link.attr('target') || '_self';
        if (url) {
          window.open(url, target);
        }
      }
    }
  });

  // Ambient videos: play only while in view, and rewind on the way out.
  ambientVideos();
  function ambientVideos() {
    var videos = document.querySelectorAll('.video-container--ambient video');
    if (!videos.length) return;

    function start(v) {
      var p = v.play();
      // Older browsers return undefined; modern ones reject if play is blocked.
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      // No observer support — fall back to just playing them.
      Array.prototype.forEach.call(videos, start);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          start(v);
        } else {
          v.pause();
          v.currentTime = 0;
        }
      });
    }, { threshold: 0.25 });

    Array.prototype.forEach.call(videos, function (v) { observer.observe(v); });
  }

  // Video Container Controls
  $('.video-container .video-button').on('click', function() {
    var $button = $(this);
    var $icon = $button.find('i');
    var $video = $button.siblings('video')[0];

    if ($video.paused) {
      $video.play();
      $video.setAttribute('controls', 'controls');
      $button.addClass('active');
      $icon.removeClass('fa-play').addClass('fa-pause');
    } else {
      $video.pause();
      $video.removeAttribute('controls');
      $button.removeClass('active');
      $icon.removeClass('fa-pause').addClass('fa-play');
    }
  });

  // Author Bio Toggle
  $('.bio-btn').on('click', function() {
    $(this).closest('.author-strap-wrapper').find('.author-strap-bio').toggle();
  });

  // News Load More — handled by newsListingFilter() below; this stub stays
  // as an explicit placeholder so the structure mirrors the other filter
  // blocks and prevents the global click handler from firing on news pages.

  // Search load-more is wired up by searchResultsFilter() below alongside
  // the type filter, so initial state and load-more share one pagination cursor.

  // Posts Carousel Video Hover
  $('.project-card').on('mouseenter', function() {
    var $wrapper = $(this);
    var $video = $wrapper.find('video');
    var $poster = $wrapper.find('.video-poster');

    if ($video.length) {
      $poster.css('opacity', '0');
      $video.css('opacity', '1');
      $video[0].play();
    }
  }).on('mouseleave', function() {
    var $wrapper = $(this);
    var $video = $wrapper.find('video');
    var $poster = $wrapper.find('.video-poster');

    if ($video.length) {
      $video.css('opacity', '0');
      $poster.css('opacity', '1');
      $video[0].pause();
      $video[0].currentTime = 0;
    }
  });

  // Carousel height = side menu height + the block's padding (xl+)
  homeHero();
  $(window).on('resize', homeHero);

  function homeHero() {
    // Sizing lives in _homepage-carousel.php (inline, so it runs before first paint).
    if (typeof window.sizeHomeCarousel === 'function') window.sizeHomeCarousel();

    // The title/pagination panel keeps its natural content height (a caption
    // within the image). Previously it was stretched up to align with the
    // side-menu bottom content, which ballooned it to ~full carousel height on
    // smaller monitors (MacBooks) and covered the image. Clear any inline
    // height so CSS controls it.
    $('.homepage-carousel-pagination-slider').css('height', '');
  }

  // Project filter — client-side. All cards are rendered on initial load and
  // the filter just toggles visibility. Mirrors the live FE portfolio's
  // shuffle behaviour and avoids a server round-trip on every click.
  projectFilter();
  function projectFilter() {
    var $filters = $('.project-filters');
    if (!$filters.length) return;

    // The server splits cards into two desktop columns by parity across the
    // *full* set (col-1 = even index, col-2 = odd). Once a filter hides part of
    // the set, the survivors can all land in one column (the Interiors bug:
    // "only uses one column when filtering"). Record the canonical order of the
    // cards per section so we can rebalance the visible ones across both
    // columns after every filter.
    $('section.standard-project-listings').each(function () {
      var $section = $(this);
      var $col1 = $section.find('.project-col-1');
      var $col2 = $section.find('.project-col-2');
      if (!$col1.length || !$col2.length) return;
      var c1 = $col1.children('.project-card').toArray();
      var c2 = $col2.children('.project-card').toArray();
      var ordered = [];
      for (var i = 0; i < Math.max(c1.length, c2.length); i++) {
        if (c1[i]) ordered.push(c1[i]);
        if (c2[i]) ordered.push(c2[i]);
      }
      $section.data('orderedCards', ordered);
    });

    // Cards vary in height (quote/award panels add ~200px), so splitting by
    // count alone leaves one column far longer. Drop each card, in order, into
    // whichever column is currently shorter. Below lg the columns are hidden
    // and heights read 0, so fall back to alternating.
    function rebalanceColumns($section) {
      var ordered = $section.data('orderedCards');
      if (!ordered) return;
      var $col1 = $section.find('.project-col-1');
      var $col2 = $section.find('.project-col-2');
      if (!$col1.length || !$col2.length) return;
      var measurable = $col1.is(':visible');
      var h1 = 0, h2 = 0, visibleIdx = 0;
      ordered.forEach(function (el) {
        var $card = $(el);
        if ($card.hasClass('is-hidden')) return;
        var toFirst = measurable ? h1 <= h2 : visibleIdx % 2 === 0;
        (toFirst ? $col1 : $col2).append($card);
        if (measurable) {
          var h = $card.outerHeight(true);
          if (toFirst) { h1 += h; } else { h2 += h; }
        }
        visibleIdx++;
      });
    }

    // Balance on load, again once fonts/images settle, and when crossing into
    // the two-column layout (card heights change per breakpoint).
    $('section.standard-project-listings').each(function () { rebalanceColumns($(this)); });
    $(window).on('load', function () {
      $('section.standard-project-listings').each(function () { rebalanceColumns($(this)); });
    });
    var rebalanceTimer;
    var lastWidth = window.innerWidth;
    $(window).on('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(rebalanceTimer);
      rebalanceTimer = setTimeout(function () {
        $('section.standard-project-listings').each(function () { rebalanceColumns($(this)); });
      }, 200);
    });

    function applyProjectFilter($section, category) {
      var $cards = $section.find('.project-grid .project-card');
      var $emptyState = $section.find('.project-grid .project-empty-state');

      var anyVisible = false;
      $cards.each(function () {
        var $card = $(this);
        var slugs = ($card.attr('data-categories') || '').split(/\s+/);
        var matches = (category === 'all') || slugs.indexOf(category) !== -1;
        $card.toggleClass('is-hidden', !matches);
        if (matches) anyVisible = true;
      });

      // Redistribute the visible cards so both desktop columns stay balanced
      // (only affects the lg+ two-column layout; the mobile single column is
      // a separate container and is untouched).
      rebalanceColumns($section);

      if (!anyVisible && !$emptyState.length) {
        $section.find('.project-grid').append('<div class="col-12 px-lg-3 project-empty-state"><p class="mb-6">Sorry but there are currently no projects avaliable.</p></div>');
      } else if (anyVisible && $emptyState.length) {
        $emptyState.remove();
      }
    }

    $filters.on('change', 'input[name="category-filter"]', function () {
      var $input = $(this);
      var $section = $input.closest('section');
      var category = $input.val();
      var $cards = $section.find('.project-grid .project-card');

      // Brief fade so the swap reads as a transition rather than a snap.
      $cards.css({ transition: 'opacity 300ms ease, transform 300ms ease', opacity: 0, transform: 'translateY(10px)' });

      setTimeout(function () {
        applyProjectFilter($section, category);

        // Set the "from" state on every visible card *without* a transition,
        // force a reflow, then enable the transition and fade in. Without this
        // pre-paint, cards that were `display: none` skip the animation when
        // they reappear (browser doesn't see a 0-opacity frame to animate from).
        var $allVisible = $section.find('.project-grid .project-card').not('.is-hidden');
        $allVisible.css({ transition: 'none', opacity: 0, transform: 'translateY(20px)' });
        if ($allVisible.length) $allVisible[0].offsetHeight; // force reflow

        // Stagger fade-in per column so col-1 and col-2 enter in parallel.
        // Cap the per-card delay so a large set never has a multi-second tail.
        var staggerMs = 5;
        var maxPerColumnDelay = 600;
        $section.find('.project-grid > [class*="project-col"]').each(function () {
          var $col = $(this);
          var $colCards = $col.find('.project-card').not('.is-hidden');
          $colCards.each(function (i) {
            var $card = $(this);
            var delay = Math.min(i * staggerMs, maxPerColumnDelay);
            setTimeout(function () {
              $card.css({ transition: 'opacity 400ms ease, transform 400ms ease', opacity: 1, transform: 'translateY(0)' });
            }, delay);
          });
        });
      }, 320);
    });

    // Honour an initial ?category-filter=… in the URL so deep links still work.
    $('section.standard-project-listings').each(function () {
      var $section = $(this);
      var $checked = $section.find('.project-filters input[name="category-filter"]:checked');
      var initialCategory = $checked.val() || 'all';
      if (initialCategory !== 'all') {
        applyProjectFilter($section, initialCategory);
      }
    });
  }

  // What's New filter — client-side. Mirrors the project-listings approach:
  // toggle `is-hidden` on items, fade in survivors per-column.
  whatsNewFilter();
  function whatsNewFilter() {
    var $filters = $('.whats-new-filters');
    if (!$filters.length) return;

    function applyWhatsNewFilter($section, category) {
      var $items = $section.find('.whats-new-item-wrapper');
      var $emptyState = $section.find('.whats-new-empty-state');

      var anyVisible = false;
      $items.each(function () {
        var $item = $(this);
        var slugs = ($item.attr('data-categories') || '').split(/\s+/);
        var matches = (category === 'all') || slugs.indexOf(category) !== -1;
        $item.toggleClass('is-hidden', !matches);
        if (matches) anyVisible = true;
      });

      if (!anyVisible && !$emptyState.length) {
        $section.find('.whats-new-grid').append('<div class="col-12 whats-new-empty-state"><p class="mb-6">Sorry but there are currently no posts available.</p></div>');
      } else if (anyVisible && $emptyState.length) {
        $emptyState.remove();
      }
    }

    $filters.on('change', 'input[name="global-category"]', function () {
      var $input = $(this);
      var $section = $input.closest('section');
      var category = $input.val();
      var $items = $section.find('.whats-new-item-wrapper');

      $items.css({ transition: 'opacity 300ms ease, transform 300ms ease', opacity: 0, transform: 'translateY(10px)' });

      setTimeout(function () {
        applyWhatsNewFilter($section, category);

        var $allVisible = $section.find('.whats-new-item-wrapper').not('.is-hidden');
        $allVisible.css({ transition: 'none', opacity: 0, transform: 'translateY(20px)' });
        if ($allVisible.length) $allVisible[0].offsetHeight; // force reflow

        var staggerMs = 5;
        var maxPerColumnDelay = 600;
        $section.find('.whats-new-col, .whats-new-col-mobile').each(function () {
          var $col = $(this);
          var $colItems = $col.find('.whats-new-item-wrapper').not('.is-hidden');
          $colItems.each(function (i) {
            var $item = $(this);
            var delay = Math.min(i * staggerMs, maxPerColumnDelay);
            setTimeout(function () {
              $item.css({ transition: 'opacity 400ms ease, transform 400ms ease', opacity: 1, transform: 'translateY(0)' });
            }, delay);
          });
        });
      }, 320);
    });

    // Honour an initial ?global-category=… deep link.
    $('section.standard-whats-new').each(function () {
      var $section = $(this);
      var $checked = $section.find('.whats-new-filters input[name="global-category"]:checked');
      var initialCategory = $checked.val() || 'all';
      if (initialCategory !== 'all') {
        applyWhatsNewFilter($section, initialCategory);
      }
    });
  }

  // Logo Grid filter AJAX
  logoGridFilter();
  function logoGridFilter() {
    var $filters = $('.logo-grid-filters');
    if (!$filters.length) return;

    $filters.on('change', 'input[name="client-category"]', function () {
      var $input = $(this);
      var $section = $input.closest('section');
      var $grid = $section.find('.logo-grid-items');
      var category = $input.val();

      // Fade out existing items
      var $existingItems = $grid.find('.logo-col');
      $existingItems.css({ transition: 'opacity 300ms ease, transform 300ms ease', opacity: 0, transform: 'translateY(10px)' });

      $.ajax({
        url: ajaxData.ajaxurl,
        type: 'POST',
        data: {
          action: 'filter_logo_grid',
          nonce: ajaxData.projectNonce,
          category: category
        },
        success: function (response) {
          if (!response.success) return;

          var cards = response.data.cards;

          setTimeout(function () {
            if (cards.length > 0) {
              $grid.html(cards.join(''));
            } else {
              $grid.html('<p class="mb-6 mb-lg-10">Sorry but there are no clients currently available.</p>');
            }

            // Animate new items in with stagger
            var $newItems = $grid.find('.logo-col');
            $newItems.css({ opacity: 0, transform: 'translateY(20px)' });

            $newItems.each(function (index) {
              var $item = $(this);
              setTimeout(function () {
                $item.css({ transition: 'opacity 400ms ease, transform 400ms ease', opacity: 1, transform: 'translateY(0)' });
              }, index * 40);
            });
          }, 320);
        }
      });
    });
  }

  // News Listing filter — client-side. Cards are pre-rendered hidden; we
  // reveal the first batch (10) of matches and let load-more page through
  // the rest of the matching set without a server round-trip.
  newsListingFilter();
  function newsListingFilter() {
    var perPage = 10;
    var $sections = $('section.standard-news-listing');
    if (!$sections.length) return;

    function getMatching($section, category) {
      var $cards = $section.find('.news-listing-wrapper .news-card-wrapper');
      if (category === 'all') return $cards;
      return $cards.filter(function () {
        var slugs = ($(this).attr('data-categories') || '').split(/\s+/);
        return slugs.indexOf(category) !== -1;
      });
    }

    function revealBatch($section, $matching, alreadyShown) {
      var $batch = $matching.slice(alreadyShown, alreadyShown + perPage);
      $batch.css({ display: '', transition: 'none', opacity: 0, transform: 'translateY(20px)' });
      if ($batch.length) $batch[0].offsetHeight; // force reflow
      $batch.each(function (i) {
        var $card = $(this);
        setTimeout(function () {
          $card.css({ transition: 'opacity 400ms ease, transform 400ms ease', opacity: 1, transform: 'translateY(0)' });
        }, Math.min(i * 5, 600));
      });
    }

    function applyFilter($section, category, animate) {
      var $allCards = $section.find('.news-listing-wrapper .news-card-wrapper');
      var $loadMoreWrapper = $section.find('.load-more-wrapper');
      var $grid = $section.find('.news-listing-wrapper');

      // Hide everything first.
      $allCards.css('display', 'none');

      var $matching = getMatching($section, category);
      $section.data('news-shown', 0);

      // Bottom margin: tighter when there's no load-more queue.
      $grid.removeClass('mb-6 mb-lg-12 mb-n6');
      $grid.addClass($matching.length > perPage ? 'mb-6 mb-lg-12' : 'mb-n6');

      if (!$matching.length) {
        $loadMoreWrapper.hide();
        if (!$section.find('.news-empty-state').length) {
          $grid.append('<div class="col-12 news-empty-state"><p class="mb-0">Sorry but there are no news articles currently available.</p></div>');
        }
        return;
      }
      $section.find('.news-empty-state').remove();

      if (animate) {
        revealBatch($section, $matching, 0);
      } else {
        // Initial render — show without staggering.
        $matching.slice(0, perPage).css('display', '');
      }
      $section.data('news-shown', Math.min(perPage, $matching.length));

      $loadMoreWrapper.toggle($matching.length > perPage);
    }

    $sections.each(function () {
      var $section = $(this);
      var $filters = $section.find('.news-listing-filters');
      var $checked = $filters.find('input[name="news-category-filter"]:checked');
      var initialCategory = $checked.val() || 'all';

      applyFilter($section, initialCategory, false);

      $filters.on('change', 'input[name="news-category-filter"]', function () {
        var category = $(this).val();
        var $existing = $section.find('.news-listing-wrapper .news-card-wrapper').filter(function () { return $(this).css('display') !== 'none'; });
        $existing.css({ transition: 'opacity 300ms ease, transform 300ms ease', opacity: 0, transform: 'translateY(10px)' });
        setTimeout(function () { applyFilter($section, category, true); }, 320);
      });

      $section.find('.load-more-btn').on('click', function () {
        var $checkedNow = $filters.find('input[name="news-category-filter"]:checked');
        var category = $checkedNow.val() || 'all';
        var $matching = getMatching($section, category);
        var shown = parseInt($section.data('news-shown'), 10) || 0;
        revealBatch($section, $matching, shown);
        var newShown = Math.min(shown + perPage, $matching.length);
        $section.data('news-shown', newShown);
        if (newShown >= $matching.length) {
          $section.find('.load-more-wrapper').hide();
        }
      });
    });
  }

  // Search Results filter — client-side. The relevanssi search itself runs
  // server-side once at page load; from there we slice by post-type or
  // project-category in the browser, with `perColumn` (5) cards revealed per
  // load-more click.
  searchResultsFilter();
  function searchResultsFilter() {
    var perColumn = 5;
    var $sections = $('section.search-results');
    if (!$sections.length) return;

    function cardMatches($card, filter) {
      if (filter === 'all') return true;
      var type = $card.attr('data-type');
      // 'news', 'page', 'linkedin-post' all map directly to data-type.
      if (filter === 'news' || filter === 'page' || filter === 'linkedin-post') {
        return type === filter;
      }
      // Anything else is a project-category slug.
      if (type !== 'project') return false;
      var slugs = ($card.attr('data-categories') || '').split(/\s+/);
      return slugs.indexOf(filter) !== -1;
    }

    function revealBatch($col, $matching, alreadyShown) {
      var $batch = $matching.slice(alreadyShown, alreadyShown + perColumn);
      $batch.css({ display: '', transition: 'none', opacity: 0, transform: 'translateY(20px)' });
      if ($batch.length) $batch[0].offsetHeight; // force reflow
      $batch.each(function (i) {
        var $card = $(this);
        setTimeout(function () {
          $card.css({ transition: 'opacity 400ms ease, transform 400ms ease', opacity: 1, transform: 'translateY(0)' });
        }, Math.min(i * 5, 600));
      });
    }

    function applyFilter($section, filter, animate) {
      var $allCards = $section.find('.search-card-wrapper');
      var $loadMoreWrapper = $section.find('.load-more-wrapper');
      var $count = $section.find('.search-results-count');

      // Hide everything
      $allCards.css('display', 'none');

      // The cards exist 3x (col-1, col-2, col-mobile). Compute matching count
      // on a single source: any one column reflects the same data set.
      var $matchingFlat = $section.find('.search-card-wrapper').filter(function () { return cardMatches($(this), filter); });
      // Count per actual unique result: each card appears once in col-mobile
      // (and once each in col-1/col-2). Use col-mobile for the unique count.
      var matchingUnique = $section.find('.search-col-mobile .search-card-wrapper').filter(function () { return cardMatches($(this), filter); }).length;

      $count.text('Results (' + matchingUnique + ')');
      $section.data('search-shown-per-col', 0);

      if (!matchingUnique) {
        $loadMoreWrapper.hide();
        if (!$section.find('.search-empty-state').length) {
          $section.find('.search-results-content').append('<div class="row search-empty-state"><div class="col-12"><div class="wysiwyg mb-6"><p>We\'re sorry, but there are no results that match your search.</p></div></div></div>');
        }
        return;
      }
      $section.find('.search-empty-state').remove();

      $section.find('.search-col, .search-col-mobile').each(function () {
        var $col = $(this);
        var $matching = $col.find('.search-card-wrapper').filter(function () { return cardMatches($(this), filter); });
        if (animate) {
          revealBatch($col, $matching, 0);
        } else {
          $matching.slice(0, perColumn).css('display', '');
        }
      });
      $section.data('search-shown-per-col', perColumn);

      // The load-more shows when any column still has hidden matches.
      var hasMore = false;
      $section.find('.search-col, .search-col-mobile').each(function () {
        var $matching = $(this).find('.search-card-wrapper').filter(function () { return cardMatches($(this), filter); });
        if ($matching.length > perColumn) hasMore = true;
      });
      $loadMoreWrapper.toggle(hasMore);
    }

    $sections.each(function () {
      var $section = $(this);
      var $filters = $section.find('.search-results-filters');
      var $checked = $filters.find('input[name="search-type-filter"]:checked');
      var initialFilter = $checked.val() || 'all';

      applyFilter($section, initialFilter, false);

      $filters.on('change', 'input[name="search-type-filter"]', function () {
        var filter = $(this).val();
        var $existing = $section.find('.search-card-wrapper').filter(function () { return $(this).css('display') !== 'none'; });
        $existing.css({ transition: 'opacity 300ms ease, transform 300ms ease', opacity: 0, transform: 'translateY(10px)' });
        setTimeout(function () { applyFilter($section, filter, true); }, 320);
      });

      $section.find('.load-more-btn').on('click', function () {
        var $checkedNow = $filters.find('input[name="search-type-filter"]:checked');
        var filter = $checkedNow.val() || 'all';
        var shown = parseInt($section.data('search-shown-per-col'), 10) || 0;
        $section.find('.search-col, .search-col-mobile').each(function () {
          var $matching = $(this).find('.search-card-wrapper').filter(function () { return cardMatches($(this), filter); });
          revealBatch($(this), $matching, shown);
        });
        var newShown = shown + perColumn;
        $section.data('search-shown-per-col', newShown);

        var hasMore = false;
        $section.find('.search-col, .search-col-mobile').each(function () {
          var $matching = $(this).find('.search-card-wrapper').filter(function () { return cardMatches($(this), filter); });
          if ($matching.length > newShown) hasMore = true;
        });
        if (!hasMore) $section.find('.load-more-wrapper').hide();
      });
    });
  }
});

/**
 * @name check_scroll
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
**/
var check_scroll = function () {
  var scroll = $(window).scrollTop();
  var $header = $('header');
  var $sideBar = $('.side-menu-wrapper');

  if (!$header.length) return;

  if (scroll > 150) {
    $header.addClass('scroll');
  } else {
    $header.removeClass('scroll');
  }

  if (!$sideBar.length) return;

  if (scroll > 1) {
    $sideBar.addClass('scroll');
    if (!$sideBar.hasClass('logo-scrolled')) {
      // Scrolled without the user doing it (reload, back/forward, #hash on
      // load): jump to the small logo rather than replaying the collapse.
      $sideBar.toggleClass('logo-instant', !userHasScrolled);
      $sideBar.removeClass('logo-restored').addClass('logo-scrolled');
    }
  } else {
    $sideBar.removeClass('scroll');
    if ($sideBar.hasClass('logo-scrolled')) {
      $sideBar.removeClass('logo-scrolled logo-instant').addClass('logo-restored');
    }
  }
};

// Set by the first real input, so restored/programmatic scrolls can be told apart.
var userHasScrolled = false;

/**
 * @name container_fix
 * @description function for fixing floating elements or page width elements with content to the conventional Bootstrap container sizes
**/
var container_fix = function () {
  var $containers = $('.container-fix');
  if (!$containers.length) return;

  var containerWidths = {
    576: 540,
    768: 720,
    992: 960,
    1200: 1140,
    1440: 1440,
  };
  var windowWidth = $(window).width();
  var containerWidth = 0;

  $.each(containerWidths, function (key, value) {
    if (windowWidth >= parseInt(key)) {
      containerWidth = value;
    }
  });

  var padding = ((windowWidth - containerWidth) / 2) + 32;

  if (windowWidth >= 992) {
    $containers.each(function () {
      var $container = $(this);
      if ($container.hasClass('odd')) {
        $container.css({ 'padding-left': '0px', 'padding-right': padding + 'px' });
      } else if ($container.hasClass('even')) {
        $container.css({ 'padding-left': padding + 'px', 'padding-right': '0px' });
      }
    });
  } else if (windowWidth >= 576 && windowWidth <= 991) {
    $containers.css({ 'padding-left': padding + 'px', 'padding-right': padding + 'px' });
  } else {
    $containers.css({ 'padding-left': '32px', 'padding-right': '32px' });
  }
};

/**
 * @name glightbox_init
 * @description initialise GLightbox for the page (replaces Magnific Popup)
**/
var glightbox_init = function () {
  if ($('.glightbox').length && typeof GLightbox !== 'undefined') {
    GLightbox({
      selector: '.glightbox',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true
    });
  }
};

/**
 * @name menu_toggle
 * @description handles opening and closing of the mobile menu on the site
 * @param {*} open flag indicating whether or not the menu is in an open state
**/
var open = false;
var menu_toggle = function (open) {
  var $burger = $('#burger');
  var $menuInner = $('#navigation-mobile');

  if ($burger.length) {
    $burger.toggleClass('open', open);
  }
  if ($menuInner.length) {
    $menuInner.toggleClass('open', open);
  }
};

/**
 * @name swiper_init
 * @description initialise Swiper carousels for the page (replaces Slick)
 * Docs: https://swiperjs.com/
 * Note: Swiper is loaded globally via swiper-bundle.min.js
**/
var swiper_init = function () {
  if (typeof Swiper === 'undefined') return;

  // Example Swiper initialization - uncomment and customize as needed
  // var carousel = new Swiper(".carousel__<name>", {
  //   slidesPerView: 1,
  //   spaceBetween: 30,
  //   autoplay: {
  //     delay: 4000,
  //     disableOnInteraction: false,
  //   },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });

  var homepageCarousel = new Swiper(".homepage-carousel-slider", {
    slidesPerView: 1,
    // No gap between image slides — a non-zero spaceBetween shows as a
    // vertical white band sliding between images during the transition.
    spaceBetween: 0,
    loop: true,
    // Slower transition so the auto-scroll feels less abrupt (Swiper default 300ms).
    speed: 1200,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var homepageCarouselPagination = new Swiper(".homepage-carousel-pagination-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    // Match the main slider's transition duration so the linked title/pagination
    // advances in lockstep with the images.
    speed: 1200,
    pagination: {
      el: ".homepage-carousel-pagination-slider .swiper-pagination",
      clickable: true,
    },
    controller: {
      control: homepageCarousel,
    },
  });

  // Pagination drives main via `controller` (set in its constructor); main
  // drives pagination via this assignment so autoplay advances both in lockstep.
  homepageCarousel.controller.control = homepageCarouselPagination;

  // Video slides: play the video and pause the carousel's auto-advance until it has
  // played for 30s (or until it ends, if it's shorter), then advance. Image slides
  // keep the normal 5s autoplay.
  var carouselVideoTimer = null;
  var CAROUSEL_VIDEO_MAX_MS = 30000;
  function handleCarouselVideos(swiper) {
    if (!swiper || !swiper.slides) return;
    // Clear any pending video-advance timer left over from the previous slide.
    if (carouselVideoTimer) { clearTimeout(carouselVideoTimer); carouselVideoTimer = null; }
    var active = swiper.slides[swiper.activeIndex];
    // Pause/reset videos on every non-active slide (incl. loop clones).
    Array.prototype.forEach.call(swiper.slides, function (slide) {
      if (slide === active) return;
      var other = slide.querySelector('video.homepage-carousel-video');
      if (other) { other.pause(); try { other.currentTime = 0; } catch (e) {} }
    });
    if (!active) return;
    var video = active.querySelector('video.homepage-carousel-video');
    if (video) {
      if (swiper.autoplay) swiper.autoplay.stop();
      try { video.currentTime = 0; } catch (e) {}
      // Advance after 30s of playback, or when the video ends if it's shorter.
      var advance = function () {
        if (carouselVideoTimer) { clearTimeout(carouselVideoTimer); carouselVideoTimer = null; }
        video.onended = null;
        swiper.slideNext();
      };
      video.onended = advance;
      // If the video can't load/play, fall back to the poster and resume autoplay.
      video.onerror = function () { if (swiper.autoplay) swiper.autoplay.start(); };
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () { if (swiper.autoplay) swiper.autoplay.start(); });
      }
      // Per-video cap from ACF (data-duration, in seconds); falls back to 30s.
      var durationAttr = parseFloat(video.getAttribute('data-duration'));
      var maxMs = durationAttr > 0 ? durationAttr * 1000 : CAROUSEL_VIDEO_MAX_MS;
      carouselVideoTimer = setTimeout(advance, maxMs);
    } else if (swiper.autoplay) {
      swiper.autoplay.start();
    }
  }
  homepageCarousel.on('slideChangeTransitionEnd', function () { handleCarouselVideos(homepageCarousel); });
  handleCarouselVideos(homepageCarousel);

  // Reset autoplay timer when the user clicks a pagination dot or swipes, so
  // the next auto-advance is a full delay later instead of firing immediately.
  function resetCarouselAutoplay() {
    if (homepageCarousel.autoplay) {
      homepageCarousel.autoplay.stop();
      homepageCarousel.autoplay.start();
    }
  }
  homepageCarousel.on('touchEnd', resetCarouselAutoplay);
  homepageCarouselPagination.on('touchEnd', resetCarouselAutoplay);
  $(document).on('click', '.homepage-carousel-pagination-slider .swiper-pagination-bullet', resetCarouselAutoplay);

  var postsCarousel = new Swiper(".posts-carousel-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      1199: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });

  var postsCarouselPagination = new Swiper(".posts-carousel-pagination-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      1199: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
    controller: {                       
      control: postsCarousel,  
    },
    pagination: {
      el: ".posts-carousel-pagination-slider .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        var svgUp = '<svg class="top-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="9" viewBox="0 0 21 9" fill="none"><path d="M19.2743 7.44793L18.0675 6.24109C12.5462 0.719811 8.47315 0.38793 2.60491 6.25618L1.39807 7.46301" stroke-width="3.95347"/></svg>';
        var svgCircle = '<svg class="centre-svg" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="4.54031" cy="4.54031" r="4.54031"/></svg>';
        var svgDown = '<svg class="bottom-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="9" viewBox="0 0 21 9" fill="none"><path d="M1.39753 1.41291L2.60437 2.61975C8.12565 8.14103 12.1987 8.47291 18.067 2.60466L19.2738 1.39783" stroke-width="3.95347"/></svg>';

        return '<span class="' + className + '">' + svgUp + svgCircle + svgDown + '</span>';
      },
    },
    navigation: {
      nextEl: ".posts-carousel-pagination-slider .swiper-button-next",
      prevEl: ".posts-carousel-pagination-slider .swiper-button-prev",
    },
  });

  var mediaGallerySlider = new Swiper(".media-gallery-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".media-gallery-slider .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
        var svgUp = '<svg class="top-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="9" viewBox="0 0 21 9" fill="none"><path d="M19.2743 7.44793L18.0675 6.24109C12.5462 0.719811 8.47315 0.38793 2.60491 6.25618L1.39807 7.46301" stroke-width="3.95347"/></svg>';
        var svgCircle = '<svg class="centre-svg" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><circle cx="4.54031" cy="4.54031" r="4.54031"/></svg>';
        var svgDown = '<svg class="bottom-svg" xmlns="http://www.w3.org/2000/svg" width="21" height="9" viewBox="0 0 21 9" fill="none"><path d="M1.39753 1.41291L2.60437 2.61975C8.12565 8.14103 12.1987 8.47291 18.067 2.60466L19.2738 1.39783" stroke-width="3.95347"/></svg>';

        return '<span class="' + className + '">' + svgUp + svgCircle + svgDown + '</span>';
      },
    },
    navigation: {
      nextEl: ".media-gallery-slider .swiper-button-next",
      prevEl: ".media-gallery-slider .swiper-button-prev",
    },
  });

  var timelineSlider = new Swiper(".timeline-slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    autoHeight: true,
    loop: true,
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
    },
    navigation: {
      nextEl: ".timeline-slider .swiper-button-next",
      prevEl: ".timeline-slider .swiper-button-prev",
    },
  });
};

/**
 * @name noticeBanner
 * @description infinite scrolling notice banner animation
**/
function noticeBanner(speed, selector) {
  $(selector).each(function () {
    var $track = $(this);
    var $originalSlides = $track.children().clone();
    var originalCount = $originalSlides.length;

    // Clone slides in original order to reach at least 4
    if (originalCount < 4) {
      var slidesNeeded = 4 - originalCount;
      for (var i = 0; i < slidesNeeded; i++) {
        var indexToClone = i % originalCount;
        $track.append($originalSlides.eq(indexToClone).clone());
      }
    }

    // Duplicate all slides to enable infinite loop
    $track.children().clone().appendTo($track);

    var position = 0;
    var lastTimestamp = null;

    function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      var delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      position -= delta * speed;

      var $firstSlide = $track.children().first();
      var firstSlideWidth = $firstSlide.outerWidth(true);

      // Shift first slide to the end once fully out of view
      if (-position >= firstSlideWidth) {
        $firstSlide.appendTo($track);
        position += firstSlideWidth;
      }

      $track.css('transform', 'translateX(' + position + 'px)');
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  });
}

/**
 * @name removeStyleTagsFromWysiwyg
 * @description removes style tags and inline styles from WYSIWYG content
**/
function removeStyleTagsFromWysiwyg() {
  $('.wysiwyg').each(function () {
    var $editor = $(this);

    // Remove all style tags from the editor content
    $editor.find('style').remove();

    // Also remove inline style attributes from all elements
    $editor.find('*').removeAttr('style');
  });
}


// Expose swiper_init to window for ACF preview
window.swiper_init = swiper_init;
